import { Row, Col, Card, Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useNotify } from '../../hooks/useNotify';
import { useLoggedInUser } from '../../hooks/useLoggedInUser';
import { userFullName } from '../../lib/utils';
import { Optional } from '../Shared';

/**
 * Displays the logged in user's account information
 */
const Account = () => {
  const { loggedInUser } = useLoggedInUser();
  const { notify } = useNotify();

  if (loggedInUser === undefined) {
    return <></>;
  }

  const userCalendarId = loggedInUser.private_calendar_id;
  const userCalendarUrl =
    userCalendarId !== undefined
      ? // TODO: Import the PRAS API from environment.
        `${location.protocol}//adapter.${location.host}/ical/${userCalendarId}`
      : 'Invalid calendar id';

  const copyCalendarUrl = () => {
    void navigator.clipboard.writeText(userCalendarUrl);
    notify.success('Calendar url copied to clipboard');
  };

  return (
    <Row>
      <Col span="flex" style={{ margin: 'auto' }}>
        <Card title={userFullName(loggedInUser)} style={{ width: '100%' }}>
          <p>Email: {loggedInUser.email_address}</p>
          <p>Username: {loggedInUser.user_name}</p>
          <p>User Type: {loggedInUser.user_type ?? 'Unknown'}</p>
          <p>Calendar integration URL:</p>
          <span
            role="textbox"
            aria-label="user calender url"
            contentEditable={false}
            style={{
              border: '1px solid #000',
              padding: '10px',
              borderRadius: '6px',
            }}
          >
            {userCalendarUrl}
            <Optional show={userCalendarId !== undefined}>
              <Button
                type="text"
                style={{ marginLeft: '6px' }}
                onClick={copyCalendarUrl}
                icon={<CopyOutlined />}
              />
            </Optional>
          </span>
        </Card>
      </Col>
    </Row>
  );
};

export default Account;
